// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"M3-z","colorTextValue":"N3-z","swatches":"O3-z","collapseLink":"P3-z","isCollapsed":"Q3-z","dropdown":"R3-z","disabled":"S3-z"};